import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateLabelShift", function updateLabelShift(title: string) {
    if (shiftEditorViewState().shift) {
        shiftEditorViewState().shift.title = title;
    }
});